import React from 'react'
import PropTypes from 'propTypes'

import { accessiblyHidden, SkeletonText } from '@offerzen/pinata-shame'
import Toolbar from '../../compounds/Toolbar'
import { css } from '@emotion/css'

const SkeletonToolbar = ({ testId }) => (
  <Toolbar testId={testId}>
    <p className={css(accessiblyHidden)}>Loading</p>
    <SkeletonText theme="dark" size="medium" width={100} />
  </Toolbar>
)

export default SkeletonToolbar

SkeletonToolbar.propTypes = {
  testId: PropTypes.string,
}
